<div class="flex flex-column">
  <div class="page">
    <h3>
      Cuestionario para la propuesta de seguro de responsabilidad civil para
      empresas de trabajos subacuáticos
    </h3>
    <form [formGroup]="subworksForm">
      <p-fieldset
        legend="1.	Nombre completo de la empresa incluyendo cualquier subsidiaria"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="name"
            class="col-12"
            labelText="Nombre completo"
            labelFor="name"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="nif"
            class="col-12 md:col-6 lg:col-4"
            labelText="CIF/DNI de la empresa"
            labelFor="nif"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="nombre_director"
            class="col-12 md:col-6 lg:col-4"
            labelText="Nombre del director"
            labelFor="nombre_director"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset legend="2. Dirección" styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="calle"
            class="col-12 md:col-6 lg:col-4"
            labelText="Calle"
            labelFor="calle"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="numero"
            class="col-12 md:col-6 lg:col-4"
            labelText="Número"
            labelFor="numero"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="piso"
            class="col-12 md:col-6 lg:col-4"
            labelText="Piso/puerta"
            labelFor="piso"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="cp"
            class="col-12 md:col-6 lg:col-4"
            labelText="Código postal"
            labelFor="cp"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="ciudad"
            class="col-12 md:col-6 lg:col-4"
            labelText="Ciudad"
            labelFor="ciudad"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="telefono"
            class="col-12 md:col-6 lg:col-4"
            labelText="Teléfono"
            labelFor="telefono"
            [required]="true"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="email"
            class="col-12 md:col-6 lg:col-4"
            labelText="EMail"
            labelFor="email"
            [group]="subworksForm"
            [required]="true">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset
        legend="3. Los siguientes trabajos están incluidos dentro del seguro"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <p>
            Trabajos subacuáticos incluyendo: peritajes, pruebas NDT,
            inspecciones, izado y colocación de estructuras, puesta y
            mantenimiento de boyas y amarres excluyendo la actividad de alquiler
            de amarres en boya, rellenado, encofrado, pilotaje, andamiaje,
            trabajos de demolición, dragado realizado por buceadores, lavado a
            presión, colocación de bloques y emisarios, soldadura, corte,
            operaciones de reflotamiento de embarcaciones de menos de 20 metros
            de eslora, operaciones de salvamento marítimo, remolque y
            utilización de embarcaciones de hasta 15 metros de eslora.
            Reparación y mantenimiento de buques, construcción y mantenimiento
            de puertos, puesta y mantenimiento de emisarios de conducción de
            agua
          </p>
          <p>
            <strong>
              Todas las actividades de preparación en superficie para estas
              actividades quedan cubiertas.
            </strong>
          </p>

          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Facturación anual"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <p>
            Si realiza alguna actividad distinta de las descritas y desea que
            queden aseguradas en la presente póliza de seguros por favor
            describa cuales son y la facturación:
          </p>

          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Otras actividades y facturación"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>

          <p>
            *Las actividades o trabajos que no estén incluidos en la lista
            arriba especificada no estarán cubiertos a menos que hayan sido
            específicamente aprobados por el asegurador.
          </p>

          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="trabajos_offshore"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              label="¿Realiza trabajos offshore?"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="trabajos_petroleo"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              label="¿Realiza trabajos en emisarios que conducen petróleo o gas?"
              classLabel="text-lg mb-1 mr-3" />
          </div>
        </div>
      </p-fieldset>

      <p-fieldset legend="4. Coberturas básicas" styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ul>
            <li>
              Responsabilidad civil de explotación…………………€1.000.000 (un millón
              de Euros)
            </li>
            <li>
              Responsabilidad civil patronal……………………......€ 601.000 con un
              sublímite por víctima de €150.000
            </li>
            <li>
              Responsabilidad civil de productos y post trabajos…€1.000.000 (un
              millón de Euros)
            </li>
          </ul>
        </div>
      </p-fieldset>

      <p-fieldset
        legend="5. Si necesitase coberturas más amplias indicarlo"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Otras coberturas"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset
        legend="6. Si realiza trabajos fuera de la Unión Europea indicar en qué países"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Otros países"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset legend="7. Explosivos" styleClass="mt-4">
        <div class="checkbox col-12">
          <app-input-switch-molecule
            [form]="subworksForm"
            name="explosivos"
            class="flex align-items-center justify-content-start flex-wrap w-full"
            label="¿Su empresa utiliza explosivos?"
            classLabel="text-lg mb-1 mr-3" />
        </div>
      </p-fieldset>

      <p-fieldset
        legend="8. Todos los trabajos hasta una profundidad de -50 mts. están incluidos; si necesita cobertura para trabajos a mayor profundidad por favor explique cómo se realizan y el equipo que se utiliza"
        styleClass="mt-4">
        <!-- <div class="checkbox col-12">
          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Descripción"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div> -->

        <div class="col-12">
          <div class="flex flex-column gap-2">
            <label for="comun" class="ml-2"> Descripción </label>
            <textarea
              pInputTextarea
              rows="6"
              formControlName="comun"
              class="w-full"></textarea>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset legend="9. Mantenimiento de equipos" styleClass="mt-4">
        <div class="checkbox col-12">
          <app-input-switch-molecule
            [form]="subworksForm"
            name="registro_mantenimiento_equipos"
            class="flex align-items-center justify-content-start w-full"
            label="¿Mantiene registro del mantenimiento de los equipos?"
            classLabel="text-lg mb-1 mr-3" />
        </div>
      </p-fieldset>

      <p-fieldset legend="10. Cobertura para maquinaria" styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="cobertura_maquinaria_sin_licencia"
              class="flex align-items-center justify-content-start w-full"
              label="¿Necesita cobertura para maquinaria, vehículos o grúas que no tengan licencia para su uso por carreteras?"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <p>
            <strong
              >IMPORTANTE: Solo quedará cubierta la responsabilidad civil de la
              maquinaria que se especifiquen a continuación por lo que si su
              respuesta es afirmativa, por favor especificar.</strong
            >
          </p>
          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Especificar"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset legend="11. Embarcaciones" styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="embarcaciones"
              class="flex align-items-center justify-content-start w-full"
              label="Su empresa es dueña o alquila embarcaciones?"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <p>
            Por favor especificar las embarcaciones que sean iguales o
            inferiores a 15 metros de eslora que son las que quedarán cubiertas
            por responsabilidad civil en la póliza.
          </p>

          <div class="flex grid m-0 align-items-center">
            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Nombre"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Eslora"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Matricula"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="*Tipo de embarcación"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>
          </div>

          <div class="col-12">
            <p-divider></p-divider>
          </div>

          <div class="flex grid m-0 align-items-center">
            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Nombre"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Eslora"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Matricula"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="*Tipo de embarcación"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>
          </div>

          <div class="col-12">
            <p-divider></p-divider>
          </div>

          <div class="flex grid m-0 align-items-center">
            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Nombre"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Eslora"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Matricula"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="*Tipo de embarcación"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>
          </div>

          <p>*(draga, apoyo en superficie, pontonas)</p>

          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Especificar"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset
        legend="12. Su empresa fabrica, vende, instala, suministra, repara o altera"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="sistemas_buceo"
              class="flex align-items-center justify-content-start w-full"
              label="Equipos o sistemas de buceo"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="producto_diferente_buceo"
              class="flex align-items-center justify-content-start w-full"
              label="Cualquier otro producto no relacionado con la industria del buceo"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <p>Si su respuesta es afirmativa, por favor dar detalles:</p>

          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Detalles"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset
        legend="13. Acuerdos de no reclamación o de renuncia a reclamar a un tercero"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="acuerdos_no_reclamacion"
              class="flex align-items-center justify-content-start w-full"
              label="¿Su empresa ha sido requerida para firmar acuerdos de no reclamación o de renuncia a reclamar a un tercero?"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <p>Si su respuesta es afirmativa, por favor dar especificar:</p>

          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Detalles"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset
        legend="14. Denegaciones, cancelaciones y términos especiales"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="subworksForm"
              name="denegaciones_especiales"
              class="flex align-items-center justify-content-start w-full"
              label="¿A su empresa le ha sido denegado, cancelado o rehusada la renovación de un seguro, o se le han impuesto términos especiales?"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <p>Si su respuesta es afirmativa, por favor dar especificar:</p>

          <ls-form-field-molecule
            formName="comun"
            class="col-12"
            labelText="Detalles"
            labelFor="comun"
            [required]="false"
            [group]="subworksForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>
      <br />
      <br />
      <p-fieldset
        legend="15. Detalle las reclamaciones o incidentes que hayan ocurrido contra su empresa durante los últimos 5 años por responsabilidad civil / Patronal"
        styleClass="mt-4">
        <p-fieldset legend="" styleClass="mt-4">
          <div class="flex grid m-0 align-items-center">
            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Año"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Patronal"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Nº reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Cantidad reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <div class="col-12">
              <p-divider class="lg:hidden"></p-divider>
            </div>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Año"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Patronal"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Nº reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Cantidad reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <div class="col-12">
              <p-divider class="lg:hidden"></p-divider>
            </div>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Año"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Patronal"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Nº reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Cantidad reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>
          </div>
        </p-fieldset>

        <p-fieldset styleClass="mt-4">
          <div class="flex grid m-0 align-items-center">
            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Año"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Explotación"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Nº reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Cantidad reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <div class="col-12">
              <p-divider class="lg:hidden"></p-divider>
            </div>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Año"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Explotación"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Nº reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Cantidad reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <div class="col-12">
              <p-divider class="lg:hidden"></p-divider>
            </div>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Año"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Explotación"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Nº reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-3"
              labelText="Cantidad reclamaciones"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>
          </div>
        </p-fieldset>
      </p-fieldset>

      <div class="mt-4">
        <p>
          <strong>
            Declaro que hasta donde alcanzan mis conocimientos que las
            respuestas dadas en la solicitud y en los documentos entregados son
            verdaderos y que no he retenido información. Acuerdo que la presente
            solicitud y los documentos que la acompañan formen parte integrante
            de la póliza de seguros a contratar.
          </strong>
        </p>
        <p-divider />
        <p>
          Para el pago de la prima del seguro deberá darnos un número de cuenta
          corriente para poder cargar la prima de seguro correspondiente.
        </p>
        <p>
          <strong
            >Mediante la presente acepto que se me cargue en la cuenta corriente
            que describo debajo los recibos que me pasará al cobro Consultores
            Segursub S.L. o las aseguradoras con las que colaboren sobre los
            contratos de seguros realizados por ésta empresa / persona física
            así como las renovaciones de los mismos.
          </strong>
        </p>

        <p-fieldset styleClass="mt-4">
          <div class="flex grid m-0 align-items-center">
            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="IBAN"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Banco"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="Sucursal"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-2"
              labelText="D.C."
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <ls-form-field-molecule
              formName="comun"
              class="col-12 sm:col-4"
              labelText="Nº. de cuenta"
              labelFor="comun"
              [required]="false"
              [group]="subworksForm">
            </ls-form-field-molecule>
          </div>
        </p-fieldset>

        <p-fieldset legend="En nombre del solicitante" styleClass="mt-4">
          <div class="flex grid m-0 align-items-center">
            <ls-form-field-molecule
              formName="firma"
              class="col-12 md:col-6"
              labelText="Firma"
              labelFor="firma"
              [required]="true"
              [group]="subworksForm">
            </ls-form-field-molecule>

            <!-- <ls-form-field-molecule
              formName="fecha"
              class="col-12 md:col-6"
              labelText="Fecha"
              labelFor="fecha"
              [required]="true"
              [group]="subworksForm">
            </ls-form-field-molecule> -->

            <div class="col-12 md:col-6 lg:col-4">
              <div class="flex flex-column gap-2 field">
                <ls-label-atom
                  for="fecha"
                  text="Fecha de la solicitud"
                  [required]="true">
                </ls-label-atom>

                <!-- [defaultDate]="defaultDate" -->
                <p-calendar
                  formControlName="fecha"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  [showButtonBar]="true"
                  [readonlyInput]="true"
                  [required]="true"
                  styleClass="w-full">
                  <ng-template pTemplate="inputicon">
                    <i class="ph ph-calendar-blank pointer-events-none"></i>
                  </ng-template>
                </p-calendar>
              </div>
            </div>

            <ls-form-field-molecule
              formName="cargo_empresa"
              class="col-12 md:col-6"
              labelText="Cargo en la empresa"
              labelFor="cargo_empresa"
              [required]="true"
              [group]="subworksForm">
            </ls-form-field-molecule>
            <!--
            <ls-form-field-molecule
              formName="fecha_inicio_seguro"
              class="col-12 md:col-6"
              labelText="Fecha inicio del seguro"
              labelFor="fecha_inicio_seguro"
              [required]="true"
              [group]="subworksForm">
            </ls-form-field-molecule> -->

            <div class="col-12 md:col-6 lg:col-4">
              <div class="flex flex-column gap-2 field">
                <ls-label-atom
                  for="fecha_inicio_seguro"
                  text="Fecha de inicio del seguro"
                  [required]="true">
                </ls-label-atom>

                <!-- [defaultDate]="defaultDate" -->
                <p-calendar
                  formControlName="fecha_inicio_seguro"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  [showButtonBar]="true"
                  [readonlyInput]="true"
                  [required]="true"
                  styleClass="w-full">
                  <ng-template pTemplate="inputicon">
                    <i class="ph ph-calendar-blank pointer-events-none"></i>
                  </ng-template>
                </p-calendar>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
    </form>
  </div>

  <p-divider></p-divider>

  <div class="flex flex-wrap justify-content-end gap-2 mt-4">
    <p-button label="Cancelar" severity="secondary" (onClick)="closeDialog()" />

    <p-button label="Solicitar presupuesto" (onClick)="sendForm()" />

    <!-- [disabled]="subworksForm.invalid"  -->
  </div>
</div>
